import { Card, CardContent, Container, Divider, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';


const skillsSet = [
    {
        iconClass: 'devicon-javascript-plain colored',
        technology: 'JavaScript'
    },
    {
        iconClass: 'devicon-typescript-plain colored',
        technology: 'TypeScript'
    },
    {
        iconClass: 'devicon-react-original colored',
        technology: 'React'
    },
    {
        iconClass: 'devicon-nodejs-plain colored',
        technology: 'Node'
    },
    {
        iconClass: 'devicon-express-original',
        technology: 'Express'
    },
    {
        iconClass: 'devicon-mongodb-plain colored',
        technology: 'MongoDB'
    },
    {
        iconClass: 'devicon-nextjs-original colored',
        technology: 'Next'
    },
    {
        iconClass: 'devicon-threejs-original',
        technology: 'Three.js'
    },
    {
        iconClass: 'devicon-mysql-plain colored',
        technology: 'MySQL'
    },
    {
        iconClass: 'devicon-html5-plain colored',
        technology: 'HTML5'
    },
    {
        iconClass: 'devicon-css3-plain colored',
        technology: 'CSS3'
    },
    {
        iconClass: 'devicon-bootstrap-plain colored',
        technology: 'Bootstrap'
    },
    {
        iconClass: 'devicon-tailwindcss-plain colored',
        technology: 'Tailwind'
    },
    {
        iconClass: 'devicon-materialui-plain colored',
        technology: 'Material UI'
    },
    {
        iconClass: 'devicon-redux-original colored',
        technology: 'Redux'
    },
    {
        iconClass: 'devicon-socketio-original colored',
        technology: 'Socket.io'
    },
    {
        iconClass: 'devicon-sass-original colored',
        technology: 'SASS'
    },
    {
        iconClass: 'devicon-git-plain-wordmark colored',
        technology: 'Git'
    },
    {
        iconClass: 'devicon-bash-plain',
        technology: 'Bash'
    },
    {
        iconClass: 'devicon-github-original',
        technology: 'Github'
    },
    {
        iconClass: 'devicon-jest-plain colored',
        technology: 'Jest'
    },
    {
        iconClass: 'devicon-firebase-plain colored',
        technology: 'Firebase'
    },
    {
        iconClass: 'devicon-heroku-plain colored',
        technology: 'Heroku'
    },
    {
        iconClass: 'devicon-figma-plain colored',
        technology: 'Figma'
    },
    {
        iconClass: 'devicon-vscode-plain colored',
        technology: 'VS Code'
    },
    {
        iconClass: 'devicon-wordpress-plain',
        technology: 'Wordpress'
    },
];

const Skills = () => {
    return (
        <Box id="skills" sx={{ flexGrow: 1, py: { xs: 150, md: 12 }, mt: { xs: '-1100px', md: '0px' } }}>

            <Container sx={{ textAlign: 'center', }}>
                <Typography sx={{ fontWeight: 500, letterSpacing: '2px' }} variant="h6" component="div">
                    SKILLSET
                </Typography>
                <Typography sx={{ fontWeight: 400, px: { xs: '10px', md: '0px' }, letterSpacing: '1px', mb: '5px' }} variant="p" component="div">
                    Skill concentration : Full-Stack Development
                </Typography>
                <Divider sx={{ width: '100px', p: 0, m: '-2px auto', border: '1px solid #FFFFFF4E' }} />
                <Divider sx={{ width: '150px', p: 0, m: '4px auto', border: '1px solid #FFFFFF4E' }} />

                <Grid sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', }} container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item sx={{ mt: 2, }} xs={4} sm={8} md={12}>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', }}>
                            {
                                skillsSet.map(skill => <Card data-aos="fade-up"
                                    data-aos-easing="ease-out-cubic"
                                    data-aos-duration="1000" sx={{ width: '135px', height: '85px', bgcolor: '#80808000', border: '1px solid #ffffff14', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px', my: 1, mx: 1 }}>
                                    <CardContent>
                                        <i style={{ fontSize: '30px' }} className={`${skill.iconClass}`}></i>
                                        <Typography sx={{ fontWeight: 500, letterSpacing: '1px', fontSize: '16px', color: 'rgba(255, 255, 255, 0.689)' }} variant="h6" component="div">
                                            {skill.technology}
                                        </Typography>
                                    </CardContent>
                                </Card>)
                            }
                            {/* <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #FFFFFF4E', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-javascript-plain colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        JavaScript
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} class="devicon-typescript-plain colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        TypeScript
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-react-original colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        React
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-nodejs-plain colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        Node
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-express-original colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        Express
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-mongodb-plain colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        MongoDB
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-html5-plain colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        HTML5
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-css3-plain colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        CSS3
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-bootstrap-plain colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        Bootstrap
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-tailwindcss-plain colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        Tailwind
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-materialui-plain colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        Material UI
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-redux-original colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        Redux
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-sass-original colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        Sass
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-git-plain-wordmark colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        Git
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} class="devicon-github-original colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        Github
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} class="devicon-jest-plain colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        Jest
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-firebase-plain colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        Firebase
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-heroku-plain colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        Heroku
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-vscode-plain colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        VS Code
                                    </Typography>
                                </CardContent>
                            </Card>

                            <Card data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000" sx={{ width: '175px', height: '110px', mt: 3, bgcolor: '#80808000', border: '1px solid #b73361c0', boxShadow: 5, mx: 1 }}>
                                <CardContent>
                                    <i style={{ fontSize: '50px' }} className="devicon-wordpress-plain colored"></i>
                                    <Typography sx={{ fontWeight: 500, letterSpacing: '1px', color: 'gray' }} variant="h5" component="div">
                                        Wordpress
                                    </Typography>
                                </CardContent>
                            </Card> */}
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Skills;